module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_8.69818db3.jpg";